import { render, staticRenderFns } from "./PatientRecommend.vue?vue&type=template&id=54976140&scoped=true"
import script from "./PatientRecommend.vue?vue&type=script&lang=js"
export * from "./PatientRecommend.vue?vue&type=script&lang=js"
import style0 from "./PatientRecommend.vue?vue&type=style&index=0&id=54976140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54976140",
  null
  
)

export default component.exports